var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { docReady } from '../helpers/docReady';
import initModal from '../sections/preview-modal';
docReady(() => {
    let recommendedProductsArray = [];
    let latestItemForRecommendations;
    const recommendationsDrawer = document.querySelector('.drawer__recommendations');
    const defaultCartRecommendationsContainers = document.querySelectorAll('[data-cart-default-recommendations]');
    const specificCartRecommendationsContainers = document.querySelectorAll('[data-cart-specific-recommendations]');
    const getRecommendedProducts = () => __awaiter(void 0, void 0, void 0, function* () {
        yield fetch('/cart.js')
            .then((data) => data.json())
            .then((res) => __awaiter(void 0, void 0, void 0, function* () {
            const cartItems = res.items;
            const latestCartItem = cartItems[0];
            const latestCartItem_id = latestCartItem === null || latestCartItem === void 0 ? void 0 : latestCartItem.id;
            const latestCartItem_handle = latestCartItem === null || latestCartItem === void 0 ? void 0 : latestCartItem.handle;
            if (cartItems.length > 0) {
                recommendationsDrawer.classList.remove('drawer__recommendations--cart-empty');
            }
            else {
                recommendationsDrawer.classList.add('drawer__recommendations--cart-empty');
            }
            if (latestCartItem_id == latestItemForRecommendations) {
                return;
            }
            else {
                latestItemForRecommendations = latestCartItem_id;
            }
            if (latestCartItem_handle) {
                yield fetch('/products/' + latestCartItem_handle + '?view=json')
                    .then((response) => {
                    return response.json();
                })
                    .then((data) => {
                    const product = data.product;
                    const recommendedProductsMetafield = product.recommended_products;
                    if (recommendedProductsMetafield) {
                        hideDefaultRecommendedProducts();
                        recommendedProductsArray = recommendedProductsMetafield;
                    }
                    else {
                        showDefaultRecommendedProducts();
                    }
                });
            }
        }));
    });
    const showDefaultRecommendedProducts = () => {
        specificCartRecommendationsContainers.forEach((container) => {
            container.style.display = 'none';
        });
        defaultCartRecommendationsContainers.forEach((container) => {
            container.style.display = 'flex';
        });
    };
    const hideDefaultRecommendedProducts = () => {
        defaultCartRecommendationsContainers.forEach((container) => {
            container.style.display = 'none';
        });
    };
    const renderRecommendedProducts = () => {
        document.dispatchEvent(new CustomEvent('cart-recommended-products-updated', {
            detail: {
                products: recommendedProductsArray,
                containers: specificCartRecommendationsContainers,
            },
        }));
    };
    const updateMiniCart = () => __awaiter(void 0, void 0, void 0, function* () {
        yield getRecommendedProducts().then(() => {
            renderRecommendedProducts();
        });
        // Preview Modal for customisable products
        initModal();
    });
    updateMiniCart();
    document.addEventListener('cart:updated', () => {
        setTimeout(() => {
            updateMiniCart();
        }, 500);
    });
    document.addEventListener('ajaxProduct:added', () => {
        setTimeout(() => {
            updateMiniCart();
        }, 500);
    });
});
